import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AppState } from '@app/reducers';
import { CommonPaginationConfig, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, prepareGetRequestHttpParams } from '@app/shared';
import { CrudService, RxjsService } from '@app/shared/services';
import { loggedInUserData } from '@modules/others';
import { Store } from '@ngrx/store';
import { TelephonyApiSuffixModules } from '@sales/shared';
@Component({
  selector: 'app-connects-ai',
  templateUrl: './connects-ai.component.html',
  styleUrls: ['./connects-ai.component.scss']
})
export class ConnectsAiComponent implements OnInit {
  @Input() value: number;
  @Input() details;
  @Output('onComplete') timerOver: EventEmitter<any> = new EventEmitter<any>();
  limit = CommonPaginationConfig.defaultPageSize;
  pageIndex: any = CommonPaginationConfig.defaultPageIndex;
  loggedInUserData: LoggedInUserModel;
  customerContactNumber;
  clientName = "";
  rawLeadId = "";
  leadId = "";
  customerId = "";
  finalMobileNumber = '';
  uniqueCallId;
  targetPosition = 0;
  clickCount = 0;
  moreCalls = [];
  recentCalls = [];
  mobile = {};
  isCallDialled = false;
  occurrenceBookId = "";
  keyHolderId = "";
  //new
  receivedScheduleCallbackDetail;
  receivedInboundCallDetail;
  receivedCustomerContactDetail;
  receivedOpenscapeConfigDetail;
  dialPadHeading = 'Dial Pad';
  isInBoundCallComing = false;
  isOutBoundCallGoing = false;
  isOpenScapeDivMaximized = false;
  showDialpadContainer = true;
  showIncomingOrOutgoingCallContainer = false;
  showOnGoingCallTimerContainer = false;
  showRecentCallLogs = false;
  selectedIndex: any;
  standardInboundCustomerDetail:any;
  selectedCustomerDetailFromCustomersListComponent:any;
  siteAddressId = "";

  // RxjsService/CrudService resolved lazily via Injector, not constructor-injected — see the
  // detailed comment in agent-login.service.ts. This avoids the @app/shared circular-import TDZ
  // without the forwardRef+any DI-registration breakage that was tried and reverted here.
  private get rxjs(): RxjsService {
    return this.injector.get(RxjsService);
  }
  private get http(): CrudService {
    return this.injector.get(CrudService);
  }

  constructor(private readonly injector: Injector,
    private readonly store: Store<AppState>,
    private readonly dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.combineLatestNgrxStoreData();
    // connects-ai does not require an agent extension number to operate, unlike OpenScape.
    // receive schedule callback observable
    this.rxjs.getscheduleCallbackDetails().subscribe((scheduleCallbackDetails) => {
      if (!scheduleCallbackDetails) {
        return;
      }
      this.receivedScheduleCallbackDetail = scheduleCallbackDetails;
      this.leadId = this.receivedScheduleCallbackDetail.leadId ? this.receivedScheduleCallbackDetail.leadId : null;
      this.customerId = this.receivedScheduleCallbackDetail.customerId ? this.receivedScheduleCallbackDetail.customerId : null;
      this.siteAddressId = this.receivedCustomerContactDetail?.siteAddressId ? this.receivedCustomerContactDetail.siteAddressId : null;
      this.finalMobileNumber = this.receivedScheduleCallbackDetail.contactNumber;
      this.finalMobileNumber = this.finalMobileNumber?.replace(/[a-z]/gi, '').replace(/ /g, '');
      if (!this.finalMobileNumber?.includes('+')) {
        this.finalMobileNumber = this.receivedCustomerContactDetail.contactNumberCountryCode + this.finalMobileNumber;
      }
      this.finalMobileNumber = this.receivedScheduleCallbackDetail.contactNumberCountryCode + this.finalMobileNumber;
      this.clientName = this.selectedCustomerDetailFromCustomersListComponent?.FullName ?
        this.selectedCustomerDetailFromCustomersListComponent.FullName : this.receivedScheduleCallbackDetail.Customers ? this.receivedScheduleCallbackDetail.Customers[0].FullName : 'Unknown';
      this.createOutboundCallToCustomer();
    });
    // receive customer contact detail observable  ( alias outbound calls from CCC to customer )
    this.rxjs.getCustomerContactNumber().subscribe((customerContactDetail) => {
      if (!customerContactDetail) {
        return;
      }
      this.isInBoundCallComing = false;
      this.isOutBoundCallGoing = true;
      this.receivedCustomerContactDetail = customerContactDetail;
      this.customerContactNumber = this.receivedCustomerContactDetail.customerContactNumber;
      this.clientName = this.receivedCustomerContactDetail.clientName;
      this.rawLeadId = this.receivedCustomerContactDetail.rawLeadId;
      this.customerId = this.receivedCustomerContactDetail.customerId ? this.receivedCustomerContactDetail.customerId : null;
      this.siteAddressId = this.receivedCustomerContactDetail?.siteAddressId ? this.receivedCustomerContactDetail.siteAddressId : null;
      this.leadId = this.receivedCustomerContactDetail.leadId;
      this.finalMobileNumber = this.receivedCustomerContactDetail.customerContactNumber.replace(/[a-z]/gi, '').replace(/ /g, '');
      if (!this.customerContactNumber?.includes('+')) {
        this.finalMobileNumber = this.receivedCustomerContactDetail.contactNumberCountryCode + this.finalMobileNumber;
      }
      this.occurrenceBookId = customerContactDetail?.occurrenceBookId ? customerContactDetail?.occurrenceBookId : null;
      this.keyHolderId = customerContactDetail?.keyHolderId ? customerContactDetail?.keyHolderId : null;
      this.createOutboundCallToCustomer();
    });
    // receive selected customer detail from the customers list when inbound call triggers
    this.rxjs.getAnyPropertyValue().subscribe((selectedCustomerDetail) => {
      if (!selectedCustomerDetail) {
        return;
      }
      if (selectedCustomerDetail.key == 'openscape module') {
        this.selectedCustomerDetailFromCustomersListComponent = selectedCustomerDetail;
        this.clientName = this.selectedCustomerDetailFromCustomersListComponent.FullName;
        this.customerContactNumber = this.standardInboundCustomerDetail?.From ? this.standardInboundCustomerDetail.From :
          this.receivedInboundCallDetail?.From ? this.receivedInboundCallDetail.From : '-';
      }
    });
  }

  resetValuesOfCallFailedOrDisconnectedProps() {
    this.dialPadHeading = 'Dial Pad';
    this.showDialpadContainer = true;
    this.showOnGoingCallTimerContainer = false;
    this.showIncomingOrOutgoingCallContainer = false;
    this.finalMobileNumber = "";
    this.isCallDialled = false;
  }

  combineLatestNgrxStoreData() {
    this.store.select(loggedInUserData)
      .subscribe((response) => {
        this.loggedInUserData = new LoggedInUserModel(response);
      });
  }

  highlightRow(e) {
    this.selectedIndex = e;
  }

  onScroll(e) {
    this.pageIndex = parseInt(this.pageIndex) + 1;
    this.getRecentCalls();
  }

  getRecentCalls() {
    this.http.get(
      ModulesBasedApiSuffix.TELEPHONY,
      TelephonyApiSuffixModules.RECENT_CALL,
      undefined,
      false, prepareGetRequestHttpParams(this.pageIndex.toString(), this.limit.toString(), {
        userId: this.loggedInUserData.userId
      })
    ).subscribe(resp => {
      if (this.pageIndex == 0) {
        this.recentCalls = resp.resources;
      } else {
        this.moreCalls = resp.resources;
        this.recentCalls = [...this.recentCalls, ...this.moreCalls];
      }
      this.rxjs.setGlobalLoaderProperty(false);
    });
  }

  numberClick(number) {
    if (this.clickCount === 0) {
      this.targetPosition = this.finalMobileNumber.length;
    }
    this.finalMobileNumber = [this.finalMobileNumber.slice(0, this.targetPosition), number, this.finalMobileNumber.slice(this.targetPosition)].join('');
    if (this.targetPosition === this.finalMobileNumber.length) {
      this.targetPosition = this.finalMobileNumber.length;
    } else {
      this.targetPosition = this.targetPosition + 1;
    }
  }

  changeInput(e) {
    this.clickCount = this.clickCount + 1;
    this.targetPosition = e.target.selectionStart;
  }

  clearNumber() {
    if (this.targetPosition === 0) {
      return;
    }
    this.finalMobileNumber = this.finalMobileNumber.slice(0, this.targetPosition - 1) + this.finalMobileNumber.slice(this.targetPosition);
    this.targetPosition = this.targetPosition - 1;
  }

  createOutboundCallToCustomer() {
    if (!this.leadId)
      this.mobile[this.finalMobileNumber] = this.finalMobileNumber
    const payload = {
      from: "",
      to: this.finalMobileNumber,
      pabxId: this.loggedInUserData.openScapePabxId,
      userId: this.loggedInUserData.userId,
      rawLeadId: this.rawLeadId ? this.rawLeadId : null,
      leadId: this.leadId ? this.leadId : null,
      customerId: this.customerId ? this.customerId : null,
      occurrenceBookId: this.occurrenceBookId ? this.occurrenceBookId : null,
      moduleType: this.occurrenceBookId ? 2 : 1,
      keyHolderId: this.keyHolderId ? this.keyHolderId : null,
    }
    if (this.isCallDialled) {
      return;
    }
    this.http.create(ModulesBasedApiSuffix.TELEPHONY, TelephonyApiSuffixModules.CUSTOMER_DIAL, payload).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode === 200) {
        this.isOpenScapeDivMaximized = true;
        this.showDialpadContainer = false;
        this.showRecentCallLogs = false;
        this.isCallDialled = true;
        this.isOutBoundCallGoing = true;
        this.dialPadHeading = 'Outgoing...';
        this.showIncomingOrOutgoingCallContainer = true;
        setTimeout(() => {
          this.showIncomingOrOutgoingCallContainer = false;
          this.showOnGoingCallTimerContainer = true;
          this.dialPadHeading = 'Active Call...';
        }, 5000);
      } else {
        this.isCallDialled = false;
        this.rxjs.setscheduleCallbackDetails(null);
        this.rxjs.setCustomerContactNumber(null);
        this.rxjs.setInboundCallDetails(null);
        this.rxjs.setAnyPropertyValue(null);
        this.showOnGoingCallTimerContainer = false;
        this.showIncomingOrOutgoingCallContainer = false;
        this.showDialpadContainer = true;
        this.isInBoundCallComing = false;
        this.isOutBoundCallGoing = false;
        this.dialPadHeading = 'Dial Pad';
      }
    });
  }

  toggleWindow(toggleType: string) {
    if (toggleType === 'minimize') {
      this.isOpenScapeDivMaximized = false;
    } else {
      this.isOpenScapeDivMaximized = true;
    }
  }

  dialPadClick() {
    if (!this.showOnGoingCallTimerContainer) {
      this.showRecentCallLogs = !this.showRecentCallLogs;
      if (this.showRecentCallLogs) {
        this.dialPadHeading = this.isInBoundCallComing ? 'Incoming Call...' : this.isOutBoundCallGoing ? 'Outgoing Call..' : 'Dial Pad';
        if (this.recentCalls.length == 0) {
          this.getRecentCalls();
        }
      }
      else {
        this.dialPadHeading = this.isInBoundCallComing ? 'Incoming Call...' : this.isOutBoundCallGoing ? 'Outgoing Call..' : 'Dial Pad';
      }
    }
  }

  createOutGoingOrAcceptIncomingCustomerCall() {
    if (!this.finalMobileNumber) {
      return;
    }
    if (this.isInBoundCallComing) {
      let payload = {
        pabxId: this.loggedInUserData.openScapePabxId,
        userId: this.loggedInUserData.userId
      }
      this.http.create(ModulesBasedApiSuffix.TELEPHONY, TelephonyApiSuffixModules.ANSWER, payload).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200) {
          this.showOnGoingCallTimerContainer = true;
          this.showIncomingOrOutgoingCallContainer = false;
          this.showDialpadContainer = false;
          this.isInBoundCallComing = false;
        }
      });
    }
  }

  disconnectCall() {
    this.mobile = {};
    const payload = {
      from: "",
      pabxId: this.loggedInUserData.openScapePabxId,
      userId: this.loggedInUserData.userId,
    };
    this.http.create(ModulesBasedApiSuffix.TELEPHONY, TelephonyApiSuffixModules.DISCONNECT, payload).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode === 200) {
        this.isCallDialled = false;
        this.rxjs.setscheduleCallbackDetails(null);
        this.rxjs.setCustomerContactNumber(null);
        this.rxjs.setInboundCallDetails(null);
        this.rxjs.setAnyPropertyValue(null);
        this.rxjs.afterCallRedirectToRespectivePage(); // Once the call is over, it will navigate to where we made the call
      }
      this.showOnGoingCallTimerContainer = false;
      this.showIncomingOrOutgoingCallContainer = false;
      this.showDialpadContainer = true;
      this.isInBoundCallComing = false;
      this.isOutBoundCallGoing = false;
      this.dialPadHeading = 'Dial Pad';
    });
  }
}
